import { render, staticRenderFns } from "./AccordionWidgets.vue?vue&type=template&id=a256129c&scoped=true"
import script from "./AccordionWidgets.vue?vue&type=script&lang=js"
export * from "./AccordionWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a256129c",
  null
  
)

export default component.exports